export default __webpack_public_path__ + "static/media/atara-german.42ca6817.png";